export default __webpack_public_path__ + "static/media/Polls.bed746e3.gif";